export default __webpack_public_path__ + "b754e0ddd24be19bc878251ce81d4455.png";